export const SET_POSTS = 'SET_POSTS'
export const ADD_POSTS = 'ADD_POSTS'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_CURRENTPOST = 'SET_CURRENTPOST'
export const SET_CURRENTCATEGORY = 'SET_CURRENTCATEGORY'
export const SET_CATEGORIES_PREVIEW = 'SET_CATEGORIES_PREVIEW'
export const ADD_CATEGORYPOSTS = 'ADD_CATEGORYPOSTS'
